exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-button-spinner[data-v-fa08ab1a]{width:1em;height:1em;vertical-align:middle}", ""]);

// exports
